module.exports = __webpack_public_path__ + "img/nav_cr_selected.f80395e0.svg";